import type { HelpFile } from '../../types/help'
import { ScriptEditorPageTestIds } from '../../../testids/ScriptEditorPageTestIds'

export const scriptEditorPageHelp: HelpFile = {
  docPage: '/docs/connectors/script-editor',
  texts: {
    [ScriptEditorPageTestIds.scriptEditorPage]:
      'In-App-Editor zum Schreiben und Speichern von Konnektor-Skripten mit Syntax-Hervorhebung und Konflikterkennung beim Speichern.',
    [ScriptEditorPageTestIds.editorToolbar]: null,
    [ScriptEditorPageTestIds.badgeUnsaved]: null,
    [ScriptEditorPageTestIds.btnBack]: null,
    [ScriptEditorPageTestIds.btnBackError]: null,
    [ScriptEditorPageTestIds.btnBackTaskNotFound]: null,
    [ScriptEditorPageTestIds.btnCancelDiscard]: null,
    [ScriptEditorPageTestIds.btnConfirmDiscard]:
      'Nicht gespeicherte Änderungen verwerfen und den Editor verlassen — dieser Schritt kann nicht rückgängig gemacht werden.',
    [ScriptEditorPageTestIds.btnConflictCancel]: null,
    [ScriptEditorPageTestIds.btnConflictReload]:
      'Aktuelle Server-Version des Skripts laden und nicht gespeicherte Änderungen verwerfen.',
    [ScriptEditorPageTestIds.btnSave]:
      'Skript speichern; erkennt parallele Bearbeitungen und zeigt bei Bedarf einen Konfliktlösungsdialog.',
    [ScriptEditorPageTestIds.editorError]: null,
    [ScriptEditorPageTestIds.editorLoading]: null,
    [ScriptEditorPageTestIds.editorTaskNotFound]:
      'Die referenzierte Aufgabe existiert nicht mehr — sie wurde möglicherweise entfernt.',
  },
}
